import ReactGA from 'react-ga4';
import ReactDOM from 'react-dom';
import { createBrowserHistory } from 'history';

const INIT_GA = 'INIT_GA';
const SET_GA_TRACKING_ID = 'SET_GA_TRACKING_ID';
const REPORT_EVENT = 'REPORT_EVENT';

const defaultState = {
    trackingID: "",
    history:null
};

export const initGA = data => {
  return {
    type: INIT_GA,
    payload: data,
  };
};

export const setTrackingID = data => {
  return {
    type: SET_GA_TRACKING_ID,
    payload: data,
  };
};

export const reportEvent = data => {
  return {
    type: REPORT_EVENT,
    payload: data,
  };
};

const gaReducer = (state = defaultState, action) => {
    switch (action.type) {
      case SET_GA_TRACKING_ID:
          state.trackingID = action.payload.trackingID;
          ReactGA.initialize(action.payload.trackingID);
        return { ...state }
      case INIT_GA:

        if (action.payload) {
          state.trackingID = action.payload.trackingID;
          ReactGA.initialize(action.payload.trackingID);

          ReactGA.set({
            userId: "visitor",
            // any data that is relevant to the user session
            // that you would like to track with google analytics
          });
        
          state.history = createBrowserHistory({
            basename: process.env.PUBLIC_URL || '/'
          });
          state.history.listen(location => {
            ReactGA.set({ page: location.pathname }); // Update the user's current page
            ReactGA.send(location.pathname); // Record a pageview for the given page
          });
        }

        return { ...state }
      
      case REPORT_EVENT:
        ReactGA.event({
          category: action.payload.category,
          action: action.payload.action
        });
        return {...state }
      default:
        return state;
    }
  };
  


export default gaReducer;
